/**
 * A hook to return categories listed on the home screen.
 *
 * @module
 */
import { useContext } from 'react';
import { HomeContext } from '../contexts';
/**
 *
 * # useHome
 *
 * Usage example:
 * ```javascript
 * import useHome from '@elevio/kb-kit/lib/hooks/useHome';
 *
 * const MyListOfHomeCategoryTitles = () => {
 *   const home = useHome();
 *   console.log(home); // IHome | undefined
 *
 *   return (
 *     <div>
 *       {home
 *         ? home.categories.map((category) => {
 *             return <div key={category.id}>{category.title}</div>;
 *           })
 *         : 'No home categories found'}
 *     </div>
 *   );
 * };
 * ```
 */
export default function useHome() {
    const categories = useContext(HomeContext);
    return categories;
}
//# sourceMappingURL=useHome.js.map